import { pathAssets } from '@/globals/globalvariables'
import type { LoaderDataTypes } from '@powerplay/core-minigames'
import { ModelsNames } from '../types'

// Hlavny priecinok s modelmi
const modelsDir = `${pathAssets}/models/`

/**
 * Konfig pre modely
 */
export const modelsConfig: LoaderDataTypes = {
  [ModelsNames.skier]: {
    version: 13,
    femaleVersion: 8,
    ext: 'glb',
    genderActive: true,
    dir: modelsDir,
    mainMeshNames: [ModelsNames.skier],
    frustumNotCulled: true
  },
  [ModelsNames.hill]: {
    version: 240117,
    ext: 'glb',
    dir: modelsDir
  },
  [ModelsNames.idealTrackIndicator]: {
    version: 2,
    ext: 'glb',
    dir: modelsDir
  },
  [ModelsNames.trackLines]: {
    ext: 'glb',
    dir: modelsDir,
    version: 7
  },
  // [ModelsNames.cameraBoxes]: {
  //   ext: 'glb',
  //   version: 240118,
  //   dir: modelsDir
  // }
}
